import { FC } from 'react'
import { useSelector } from '../../store'

import './Preloader.scss'
export enum PRELOADER_TYPE {
  SIMPLE = 'simple',
  LOADING_CONTENT = 'loading-content'
}

type PreloaderProps = {
  isGlobal?: boolean
  type?: PRELOADER_TYPE | undefined
}

const Preloader: FC<PreloaderProps> = ({ isGlobal = false, type = PRELOADER_TYPE.SIMPLE}) => {
  const isShow = useSelector(({ preloader: { isShow } }) => isShow)
  let preloaderContent = null

  switch (type) {
    case PRELOADER_TYPE.SIMPLE: {
      preloaderContent = (
        <div className={`main-preloader ${isGlobal && 'global'}`}>
          <div className='main-preloader__spinner' />
        </div>
      )
      break
    }
    case PRELOADER_TYPE.LOADING_CONTENT: {
      preloaderContent = <div className='main-preloader__preloader-content'>
        <div className='main-preloader__preloader-content__title'>Please Wait</div>
        <div className='main-preloader__preloader-content__descr'>Content is loading...</div>
        <div className='main-preloader__preloader-content__spinner'></div>
      </div>
      break
    }
    default: {
      preloaderContent = (
        <div className={`main-preloader ${isGlobal && 'global'}`}>
          <div className='main-preloader__spinner' />
        </div>
      )
    }
  }

  return (isGlobal && isShow) || !isGlobal ? preloaderContent : null
}

export default Preloader
